import { AppTheme } from '@data/index';
import { PoweredByCurewikiLogo, PublicPageLogo } from '@ui/components';
import { isYWC, isBHS, isPCE, isPEC } from '@ui/constants';
import { BHSLogo, PCELogoPublic, PECLogo, YWCLogo } from '@ui/icons';

export const getCurrentAppTheme = () => {
  switch (true) {
    case isYWC:
      return {
        theme: AppTheme.YES_WE_CANCER,
        PublicLogo: YWCLogo,
        publicLogoProps: { className: 'ml-[-65px] flex' },
        AdditionalLogo: PoweredByCurewikiLogo,
        additionalLogoProps: { className: 'mt-6' },
      };

    case isBHS:
      return {
        theme: AppTheme.BHS,
        PublicLogo: BHSLogo,
        publicLogoProps: { className: 'h-12 w-auto mb-6' },
        AdditionalLogo: PoweredByCurewikiLogo,
        additionalLogoProps: { className: 'mt-6' },
      };

    case isPCE:
      return {
        theme: AppTheme.PCE,
        PublicLogo: PCELogoPublic,
        publicLogoProps: { className: 'w-[100px] h-auto' },
        AdditionalLogo: PoweredByCurewikiLogo,
        additionalLogoProps: { className: 'mt-6' },
      };

    case isPEC: {
      return {
        theme: AppTheme.PEC,
        PublicLogo: PECLogo,
        publicLogoProps: { className: 'h-auto' },
        AdditionalLogo: PoweredByCurewikiLogo,
        additionalLogoProps: { className: 'mt-6' },
      };
    }

    default:
      return {
        theme: AppTheme.CUREWIKI,
        PublicLogo: PublicPageLogo,
        publicLogoProps: {},
        AdditionalLogo: PublicPageLogo,
        additionalLogoProps: {
          className: 'hidden',
        },
      };
  }
};
